import { Backdrop, Box, Button, Checkbox, CircularProgress, Divider, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Radio, RadioGroup, Snackbar, Stack, TextField, Typography } from '@mui/material'
import Select from 'react-select';
import React, { useRef, forwardRef, useState } from 'react'
import customStyles from 'app/shared-components/SelectCustomStyle'
import QuestionListIcon from 'src/assets/question-list.png'
import { FastForwardOutlined } from '@mui/icons-material';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import OAuthService from 'src/app/auth/services/oAuthService';
import { useEffect } from 'react';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { useImperativeHandle } from 'react';
import jwtDecode from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';

const ShowroomQuestinaries = forwardRef((props, ref) => {
    const dsTask = JSON.parse(localStorage.getItem('dsTask'));
    const backAction = localStorage.getItem('backAction')
    const token = localStorage.getItem('token');
    const navigate = useNavigate()
    const formRef = useRef();
    const hiddenDrawingFile = useRef(null);
    const hiddenSitePhotosFile = useRef(null);
    const hiddenFile = useRef(null);
    const [partnerOptions, setPartnerOptions] = useState()
    const [partnerId, setPartnerId] = useState();
    const [partnerName, setPartnerName] = useState();
    const [dataObj, setDataObj] = useState()
    const [showroomId, setShowroomId] = useState();
    const [showroomName, setShowroomName] = useState();
    const [showroomOptions, setShowroomOptions] = useState()
    const [showroomQuestions, setShowroomQuestions] = useState()
    const [editData, setEditData] = useState()
    const [dsTaskAssignmentFiles, setDsTaskAssignmentFiles] = useState([])
    const [sitePhotos, setSitePhotos] = useState([])
    const [drawings, setDrawings] = useState([])
    const [allFilesImages, setAllFilesImages] = useState([])
    const [checkedData, setCheckedData] = useState([])
    const [loading, setLoading] = useState(false)
    const [backdropOpen, setBackdropOpen] = useState(false)
    const [checkStatus, setCheckStatus] = useState(true);
    const [successMsg, setSuccessMsg] = useState();
    const [openSnack, setOpenSnack] = useState(false);

    const params = dsTask ? { ...props, id: dsTask?.dsTaskId } : props;

    useEffect(() => {
        params?.checkedStatus(checkStatus)
    }, [checkStatus])

    const shrQuestionnaires = async () => {
        try {
            setLoading(true);
            setBackdropOpen(true);
            const dsQuestonnariesUrl = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsQuestionnaires}`;
            const dsShmQuestionnaires = await OAuthService.getList(`${dsQuestonnariesUrl}/search/findByDesignStudioCategory?designStudioCategory=SHR`)
            console.log('dsShmQuestionnaires', dsShmQuestionnaires)

            const result = dsShmQuestionnaires?.data?._embedded?.dsQuestionnaires?.map((value) => {
                return { ...value, quesId: value.quesId, question: value.question, options: value.options, fieldType: value.dsUiComphonent }
            })
            console.log('result', result)
            setShowroomQuestions(result)
            setLoading(false);
            setBackdropOpen(false)
        } catch (error) {
            setLoading(false)
            console.log(error, "error")
        }
    }
    const partners = async () => {
        const decode = jwtDecode(token);
        const findAllByAreaManagerUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territoryList}/search/findAllByAreaManagerContains?email=${decode.email}`;
        const areaManager = await OAuthService.getList(findAllByAreaManagerUrl);
        const areaManagerId = areaManager?.data?._embedded?.territories[0]?.id

        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/search/findByTerritoryAndActive?territory=${areaManagerId}&active=true`;
        const partners = await OAuthService.getList(url);

        const result = partners?.data?._embedded?.companies.map((value) => {
            return { label: `${value?._links.company.href.split('/').pop()} ${value.name}`, value: value.name, id: value?._links.company.href.split('/').pop() }
        })
        setPartnerOptions(result);
    }

    const showrooms = async () => {
        if (partnerId) {
            const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/showroomsByCompanyNum?companyNum=${partnerId}&size=100`;
            const showrooms = await OAuthService.getList(url);

            const result = showrooms?.data?.result?.map((value) => {
                return { label: `${value.id} ${value.text}`, value: value.text, id: value?.id }
            })
            setShowroomOptions(result);
        }
    }

    const handleShowroomChange = (data) => {
        setShowroomId(data.id);
        setShowroomName(data.value);
        setEditData({ ...editData, showroom: data.value })
    };
    const handlePartnerChange = async (data) => {
        setPartnerName(data.value);
        setPartnerId(data.id);
        setEditData({ ...editData, partner: data.value })
    };

    useEffect(() => {
        shrQuestionnaires();
        partners();
    }, [])

    useEffect(() => {
        showrooms()
        setShowroomId()
    }, [partnerId])

    useEffect(() => {
        if (editData) {
            const editFn = async () => {

                const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/showroomsByCompanyNum?companyNum=${partnerId || editData?.partnerId}&size=100`;
                const showrooms = await OAuthService.getList(url);

                const result = showrooms?.data?.result?.map((value) => {
                    return { label: `${value.id} ${value.text}`, value: value.text, id: value?.id }

                })
                setShowroomOptions(result);
            }
            editFn()
        }
    }, [editData])

    useEffect(() => {
        if (backAction == true || backAction == "true") {
            if (dsTask) {
                setEditData(dsTask)
                setDataObj(dsTask && dsTask.dsQuestionnaires && dsTask.dsQuestionnaires)
                setShowroomQuestions(dsTask && dsTask.dsQuestionnaires && dsTask.dsQuestionnaires)
            }
        }
    }, [backAction])

    const uploadFiles = async (data, btnType) => {
        // const allFileImages = allFilesImages.flat();
        const dsTaskFiles = dsTaskAssignmentFiles ? [...dsTaskAssignmentFiles] : []
        const dsTaskSitePhotos = sitePhotos ? [...sitePhotos] : []
        const dsTaskDrawings = drawings ? [...drawings] : []
        const formData = new FormData();

        dsTaskFiles.forEach((file) => formData.append('files', file))
        dsTaskSitePhotos.forEach((file) => formData.append('sitePhotos', file))
        dsTaskDrawings.forEach((file) => formData.append('drawings', file))

        await OAuthService.addFiles(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsUploadMultipleFiles}?dsTaskId=${data?.dsTaskId}&category=${data?.designStudioCategory}&updatedBy=${data.modifiedByUser}`, formData)
            .then((response) => {
                if (btnType === 'draft') {
                    navigate('/design-studio-dashboard')
                } else {
                    localStorage.setItem('dsTask', JSON.stringify(response.data))
                }
            }).catch((err) => console.log(err, "uploadFiles"))
    }

    const handleSaveDraft = async () => {
        const decode = jwtDecode(token);
        let model = {
            ...editData,
            partnerId: partnerId || editData?.partnerId,
            partner: partnerName || editData?.partner,
            showroomId: showroomId || editData?.showroomId,
            showroom: showroomName || editData?.showroom,
            dsQuestionnaires: showroomQuestions || editData?.dsQuestionnaires,
            designStudioCategory: editData?.designStudioCategory || props.designStudioCategory,
            isDsLifeCyclePassForNextState: false,
            isDsStatusPassForNextState: false,
            createdByUser: decode.email,

        }

        try {
            if (params?.id || dsTask) {
                await OAuthService.putData(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignment}/${params.id || dsTask?.dsTaskId}`, model)
                    .then((res) => {
                    })
                    .catch((err) => console.log(err));
                uploadFiles(model, "draft")
                navigate('/design-studio-dashboard')

            } else {
                await OAuthService.addData(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignment}`, model).then(async (res) => {
                    if (res.data) {
                        uploadFiles(res.data, 'draft')

                    }
                    navigate('/design-studio-dashboard')

                });
            }
        } catch (error) {
            console.log(error, "error")
            // setError(error.message)
            return;
        }
    }

    const handleSubmit = async () => {
        // setCheckStatus(true)
        const decode = jwtDecode(token);
        let model = {
            ...editData,
            partnerId: partnerId || editData?.partnerId,
            partner: partnerName || editData?.partner,
            showroomId: showroomId || editData?.showroomId,
            showroom: showroomName || editData?.showroom,
            dsQuestionnaires: showroomQuestions || editData?.dsQuestionnaires,
            designStudioCategory: editData?.designStudioCategory || props.designStudioCategory,
            isDsLifeCyclePassForNextState: false,
            isDsStatusPassForNextState: false,
            createdByUser: decode.email,
        }

        try {
            if (params?.id) {
                // const data = { ...model, isDsStatusPassForNextState: true }
                await OAuthService.putData(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignment}/${params.id}`, model)
                    .then(async (res) => {
                    })
                    .catch((err) => console.log(err));
                uploadFiles(model, 'submit')

                setSuccessMsg("Data updated SuccessFully.");
                setOpenSnack(true);
                navigate('/new-request-calendar');
                return "Data updated SuccessFully.";
            } else {
                await OAuthService.addData(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignment}`, model).then(async (res) => {
                    if (res.data) {
                        localStorage.setItem('dsTask', JSON.stringify(res.data))
                        uploadFiles(res.data, 'submit')
                    }
                    navigate('/new-request-calendar')

                });
            }
            // setSuccessMsg("Data Saved SuccessFully.");
            // setOpenSnack(true);
        } catch (error) {
            console.log(error, "error")
            // setError(error.message)
            return;
        }
    }

    useEffect(() => {
        params.checkedStatus(checkStatus)
    }, [checkStatus])

    useImperativeHandle(ref, () => ({
        handleSubmit: handleSubmit,
        handleSaveDraft: handleSaveDraft
    }))

    const handleDocumentChange = (e) => {
        setAllFilesImages(allFilesImages && [...allFilesImages, Array.from(e.target.files)])
        setDsTaskAssignmentFiles(e.target.files);
    }

    const handleSitePhotosChange = (e) => {
        setAllFilesImages(allFilesImages && [...allFilesImages, Array.from(e.target.files)])
        setSitePhotos(e.target.files);
    }

    const handleDrawingChange = (e) => {
        setAllFilesImages(allFilesImages && [...allFilesImages, Array.from(e.target.files)])
        setDrawings(e.target.files);
    }

    useEffect(() => {
        if (showroomQuestions) {
          const checkComments = showroomQuestions.filter((ele) => ele.answer === 'Yes' && (ele.quesId === 3 ||
            ele.quesId === 5 ||
            ele.quesId === 13 ||
            ele.quesId === 14 ||
            ele.quesId === 16) && (ele.comment === null || ele.comment === ""))
            if (params?.id || dsTask) {
                const data = showroomQuestions.every((ele) => ele.answer != null || ele?.answer != "")
                if (data == true && checkComments.length <= 0 && partnerName && showroomName && (dsTaskAssignmentFiles != null || dsTaskAssignmentFiles?.length > 0) && (sitePhotos != null || sitePhotos?.length > 0) && (drawings != null || drawings?.length > 0)) {
                    setCheckStatus(false)
                } else {
                    setCheckStatus(true)
                }
            } else {
                // for (let i = 0; i < showroomQuestions.length; i++) {
                //     if (partnerId == undefined || partnerName == undefined || showroomId == undefined ||  showroomName == undefined || sitePhotos.length == 0 || drawings.length == 0 || dsTaskAssignmentFiles.length == 0 || showroomQuestions[i].answer == null) {
                //         setCheckStatus(true)
                //     } else {
                //         setCheckStatus(false)
                //     }
                // }
                      
                const data = showroomQuestions.every((ele) => ele.answer != null)
                if (data == true && checkComments.length <= 0 && partnerName && showroomName && dsTaskAssignmentFiles.length > 0 && sitePhotos.length > 0 && drawings.length > 0) {
                    setCheckStatus(false)
                } else {
                    setCheckStatus(true)
                }
            }
        }
    }, [showroomQuestions, dsTaskAssignmentFiles, sitePhotos, drawings, partnerId, partnerName, showroomId, showroomName])

    const editDsTask = async () => {
        const url = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignment}/${params?.id}`;
        const result = await OAuthService.getList(url);
        setDataObj(result.data.dsQuestionnaires)
        setShowroomQuestions(result.data.dsQuestionnaires)
        setEditData(result.data)
        setDsTaskAssignmentFiles(result.data.dsTaskAssignmentFiles)
        setSitePhotos(result.data.sitePhotosFiles)
        setDrawings(result.data.drawingsFiles)
        setPartnerId(result.data.partnerId)
        setPartnerName(result.data.partner)
        setShowroomId(result.data.showroomId)
        setShowroomName(result.data.showroom)
        // localStorage.setItem('dsTask', JSON.stringify(result.data))
    }

    useEffect(() => {
        if (params?.id) {
            editDsTask();
        }
    }, [params?.id])

    const handleRadioChange = (e, data) => {
        const updatedValue = { ...data, answer: e.target.value }
        const updated = updateShrQuestions(updatedValue)
        setShowroomQuestions(updated)
    }
    const updateComment = (e, data) => {
        const updatedValue = { ...data, comment: e.target.value }
        const updated = updateShrQuestions(updatedValue)
        setShowroomQuestions(updated)
    }

    const handleCheckbox = (e, data) => {
        const { value, checked } = e.target
        setDataObj(data)
        if (checked) {
            setCheckedData((prevValues) => [...prevValues, value])
        } else {
            setCheckedData((prevValues) => prevValues.filter((data) => data !== value))
        }
    }

    useEffect(() => {
        if (dataObj) {
            const updatedValue = { ...dataObj, answer: checkedData?.join(',') }
            const updated = updateShrQuestions(updatedValue)
            setShowroomQuestions(updated)
        }
    }, [checkedData, dataObj])

    useEffect(() => {
        if (dataObj) {
            if (dataObj[0] || dataObj[7]) {
                const d = (dataObj[0] || dataObj[7]).answer?.split(",")
                setCheckedData(checkedData?.concat(d))
            }
        }
    }, [dataObj])

    const updateShrQuestions = (updatedValue) => {
        const foundIndex = showroomQuestions.findIndex(x => x?.quesId == updatedValue?.quesId)
        if (foundIndex != -1) {
            const updatedQuestions = [...showroomQuestions]
            updatedQuestions[foundIndex] = updatedValue
            return updatedQuestions
        }
        return showroomQuestions
    }

    const handleSnackClose = (e) => {
        setOpenSnack(false)
    }

    const handleRemoveFile = (index, name, type) => {
        if (type === 'files') {
            setDsTaskAssignmentFiles([...dsTaskAssignmentFiles].filter((_, i) => i !== index));
            hiddenFile.current.value = null;
        } else if (type === 'sitePhoto') {
            setSitePhotos([...sitePhotos].filter((_, i) => i !== index))
            hiddenSitePhotosFile.current.value = null;
        } else if (type === 'drawings') {
            setDrawings([...drawings].filter((_, i) => i !== index))
            hiddenDrawingFile.current.value = null;
        }
        setAllFilesImages(allFilesImages.flat().filter((obj) => (obj.name || obj?.fileName) !== name))
    }

    const [qty, setQty] = useState(1);

    const handleQtyChange = (event) => {
        const inputValue = event.target.value;
        if (!isNaN(inputValue)) {
            const numberValue = parseFloat(inputValue);
    
            if (numberValue >= 1 && numberValue <= 10) {
                setQty(numberValue.toString());
            }
        }
    }

    return (
      <>
        <div className="w-full">
          <div>
            <FormControl ref={formRef} className="flex flex-col justify-center">
              <Grid
                container
                spacing={2}
              >
                <Grid item xs={5}>
                  <Stack>
                    <label>*Select Partner</label>
                    <Select
                      value={
                        editData &&
                        partnerOptions &&
                        partnerOptions?.filter((obj) =>
                          editData.partner?.includes(obj.value)
                        )
                      }
                      options={partnerOptions}
                      styles={customStyles()}
                      className="select mt-10"
                      getOptionValue={(option) => `${option["id"]}`}
                      onChange={handlePartnerChange}
                    />
                  </Stack>
                </Grid>
                  <Grid item xs={6}>
                    <Stack>
                      <label>*Select Showroom</label>
                      <Select
                        value={
                          editData &&
                          showroomOptions &&
                          showroomOptions?.filter((obj) =>
                            editData.showroom?.includes(obj.value)
                          )
                        }
                        options={showroomOptions}
                        styles={customStyles()}
                        className="select mt-10"
                        getOptionValue={(option) => `${option["id"]}`}
                        onChange={handleShowroomChange}
                      />
                    </Stack>
                  </Grid>
              </Grid>
              <Grid display="flex" className="mb-20 mt-20 ">
                <img src={QuestionListIcon} alt="" className="h-40 w-40" />
                <Typography className="text-3xl font-semibold ml-20">
                  Questionnaire
                </Typography>
              </Grid>
              <Divider className="mb-20 " />
              {loading ? (
                <Backdrop
                  sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={backdropOpen}
                >
                  <CircularProgress color="inherit" />
                  <Typography>Please wait while the data loads.</Typography>
                </Backdrop>
              ) : (
                <div>
                    <Grid>
                      {(showroomQuestions && showroomQuestions)?.map(
                        (value, i) => (
                          <>
                            <Grid item>
                              <Stack>
                                <label className="questions mb-20">{`${value.quesId}. *${value.question}`}</label>
                              </Stack>
                            </Grid>
                            <Grid item>
                              <Stack
                                direction="row"
                                spacing={2}
                                className="mb-20"
                              >
                                {(value?.fieldType || value?.dsUiComphonent) ===
                                  "RADIO" && (
                                  <RadioGroup
                                    row
                                    className="questions"
                                    value={value?.answer}
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    onChange={(e) =>
                                      handleRadioChange(e, value)
                                    }
                                  >
                                    {value?.options?.map((obj, i) => {
                                      return (
                                        <FormControlLabel
                                          className="questions"
                                          value={obj}
                                          control={<Radio />}
                                          label={obj}
                                          key={i}
                                        />
                                      );
                                    })}
                                  </RadioGroup>
                                )}
                                {(value?.dsUiComphonent || value?.fieldType) ===
                                  "MULTI_SELECT" && (
                                  <>
                                    {value?.options?.map((obj, i) => (
                                      <FormControlLabel
                                        className="questions"
                                        label={obj}
                                        key={i}
                                        value={obj}
                                        control={
                                          <Checkbox
                                            checked={value?.answer?.includes(
                                              obj
                                            )}
                                            onChange={(e) =>
                                              handleCheckbox(e, value)
                                            }
                                          />
                                        }
                                      />
                                    ))}
                                  </>
                                )}
                                {(value?.dsUiComphonent || value?.fieldType) ===
                                  "TEXT" && (
                                  <TextField
                                    className="w-1/2"
                                    onChange={(e) =>
                                      handleRadioChange(e, value)
                                    }
                                    value={value?.answer || ""}
                                  />
                                )}
                              </Stack>
                              {(value.quesId === 3 ||
                                value.quesId === 5 ||
                                value.quesId === 13 ||
                                value.quesId === 14 ||
                                value.quesId === 16) && (
                                <div>
                                  <TextField
                                    type="text"
                                    className="w-1/2 mb-20"
                                    multiline
                                    rows={3}
                                    value={value?.comment || ""}
                                    onChange={(e) => updateComment(e, value)}
                                    // onChange={(e) => handleComment(e.target.value, value)}
                                    placeholder="If yes, comment is mandatory"
                                  />
                                </div>
                              )}
                            </Grid>
                          </>
                        )
                      )}
                    </Grid>
                </div>
              )}
              <Divider className="mb-20 mt-10" />
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Stack className="w-full mb-16">
                    <label>*Upload your files</label>
                    <Box
                      className="flex justify-center items-center mt-10"
                      sx={{
                        height: 95,
                        border: "1px dotted #FFFFFF",
                      }}
                    >
                      <CloudUploadOutlinedIcon fontSize={"large"} />
                      <Typography className="ml-12 text-xs">
                        Upload your files here or
                      </Typography>
                      <Button
                        variant="outlined"
                        component="label"
                        color="warning"
                        className="ml-12 w-96"
                      >
                        <input
                          hidden
                          multiple
                          type="file"
                          onChange={(e) => handleDocumentChange(e)}
                          ref={hiddenFile}
                        />
                        <Typography color="#FFA726">Browse</Typography>
                      </Button>
                    </Box>
                    <div>
                      {dsTaskAssignmentFiles &&
                        [...dsTaskAssignmentFiles]?.map((obj, i) => (
                          // <div>{obj?.name}</div>
                          <ul>
                            <li key={i}>
                              {obj?.name || obj?.fileName}
                              <Button
                                onClick={() =>
                                  handleRemoveFile(
                                    i,
                                    obj?.name || obj?.fileName,
                                    "files"
                                  )
                                }
                              >
                                <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                              </Button>
                            </li>
                          </ul>
                        ))}
                    </div>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack className="w-full mb-16">
                    <label>*Upload your Site Photos</label>
                    <Box
                      className="flex justify-center items-center mt-10"
                      sx={{
                        height: 95,
                        border: "1px dotted #FFFFFF",
                      }}
                    >
                      <CloudUploadOutlinedIcon fontSize={"large"} />
                      <Typography className="ml-12 text-xs">
                        Upload your files here or
                      </Typography>
                      <Button
                        variant="outlined"
                        component="label"
                        color="warning"
                        className="ml-12 w-96"
                      >
                        <input
                          hidden
                          multiple
                          type="file"
                          onChange={(e) => handleSitePhotosChange(e)}
                          ref={hiddenSitePhotosFile}
                        />
                        <Typography color="#FFA726">Browse</Typography>
                      </Button>
                    </Box>
                    <div>
                      {sitePhotos &&
                        [...sitePhotos]?.map((obj, i) => (
                          // <div>{obj?.name}</div>
                          <ul>
                            <li key={i}>
                              {obj?.name || obj?.fileName}
                              <Button
                                onClick={() =>
                                  handleRemoveFile(
                                    i,
                                    obj?.name || obj?.fileName,
                                    "sitePhoto"
                                  )
                                }
                              >
                                <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                              </Button>
                            </li>
                          </ul>
                        ))}
                    </div>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack className="w-full mb-16">
                    <label>*Upload your Drawings</label>
                    <Box
                      className="flex justify-center items-center mt-10"
                      sx={{
                        height: 95,
                        border: "1px dotted #FFFFFF",
                      }}
                    >
                      <CloudUploadOutlinedIcon fontSize={"large"} />
                      <Typography className="ml-12 text-xs">
                        Upload your files here or
                      </Typography>
                      <Button
                        variant="outlined"
                        component="label"
                        color="warning"
                        className="ml-12 w-96"
                      >
                        <input
                          hidden
                          multiple
                          type="file"
                          onChange={(e) => handleDrawingChange(e)}
                          ref={hiddenDrawingFile}
                        />
                        <Typography color="#FFA726">Browse</Typography>
                      </Button>
                    </Box>
                    <div>
                      {drawings &&
                        [...drawings]?.map((obj, i) => (
                          // <div>{obj?.name}</div>
                          <ul>
                            <li key={i}>
                              {obj?.name || obj?.fileName}
                              <Button
                                onClick={() =>
                                  handleRemoveFile(
                                    i,
                                    obj?.name || obj?.fileName,
                                    "drawings"
                                  )
                                }
                              >
                                <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                              </Button>
                            </li>
                          </ul>
                        ))}
                    </div>
                  </Stack>
                </Grid>
              </Grid>
            </FormControl>
          </div>
        </div>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={openSnack}
          //   autoHideDuration={6000}
          onClose={handleSnackClose}
          message={successMsg}
          action={
            <>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleSnackClose}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </>
          }
        />
      </>
    );
})

export default ShowroomQuestinaries